module.exports = __webpack_public_path__ + "bcfddf233b6ab198eecd959e28126517.pdf";